import { apiService } from "../api.service";
import {NextPrice} from "../../models/prices/price";

export class PricesService {
    public async getNextPrice(): Promise<NextPrice> {
        return (await apiService.get<NextPrice>("prices/next-price")).data;
    }
}

export const pricesService = new PricesService();
